import { useScrollTo } from '../../../hooks/useScrollTo';

export default function ScrollButton({ targetId }) {
  const scrollTo = useScrollTo();

  const handleClick = () => {
    scrollTo(targetId);
  };

  return (
    <button
      onClick={handleClick}
      className="w-52 bg-gradient-to-r from-emerald-600 to-green-700 text-white py-3 rounded-full hover:scale-105 hover:from-emerald-500 hover:to-green-600 transition-all duration-300 shadow-lg shadow-emerald-500/25"
    >
      View My Work
    </button>
  );
}